import { render, staticRenderFns } from "./SimpleRule.vue?vue&type=template&id=3c5b3533&scoped=true"
import script from "./SimpleRule.vue?vue&type=script&lang=ts"
export * from "./SimpleRule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b3533",
  null
  
)

export default component.exports